import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import logo from "../assets/logo.jpg";

export default function Navbar() {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const links = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Services", path: "/services" },
    { name: "Careers", path: "/careers" },
    { name: "Contact", path: "/contact" },
    { name: "Policies", path: "/policies" },
  ];

  return (
    <nav className="sticky top-0 z-50 bg-white shadow px-6 md:px-10 py-4">
      {/* TOP BAR */}
      <div className="flex justify-between items-center">
        {/* LOGO  */}
        <div className="flex flex-col items-center leading-none">
          <img src={logo} alt="Logo" className="w-14 h-14 object-contain" />

          <span className="text-black text-sm font-medium mt-1 ml-1">
            {/* DELIVERY */}
          </span>
        </div>

        {/* LINKS */}
        <ul className="hidden md:flex gap-6 text-gray-700">
          {links.map((link) => (
            <li key={link.name}>
              <Link
                to={link.path}
                className={`hover:text-orange-500 ${
                  location.pathname === link.path
                    ? "text-orange-500 border-b-2 border-orange-500"
                    : ""
                }`}
              >
                {link.name}
              </Link>
            </li>
          ))}
        </ul>

        {/* BUTTON */}
        <button className="hidden md:block bg-orange-500 text-white px-4 py-2 rounded-full">
          Request Delivery
        </button>

        {/* MOBILE MENU */}
        <button className="md:hidden" onClick={() => setOpen(!open)}>
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* MOBILE MENU/SMALL SCREENS */}
      {open && (
        <div className="md:hidden mt-4 bg-white border-t pt-4">
          <ul className="flex flex-col gap-4 text-gray-700">
            {links.map((link) => (
              <li key={link.name}>
                <Link
                  to={link.path}
                  onClick={() => setOpen(false)}
                  className={`block py-2 ${
                    location.pathname === link.path
                      ? "text-orange-500 font-semibold"
                      : ""
                  }`}
                >
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>

          <button className="mt-4 w-full bg-orange-500 text-white py-2 rounded-full">
            Request Delivery
          </button>
        </div>
      )}
    </nav>
  );
}
